function anonymizeEmail(email: string) {
  if (typeof email !== "string" || !email.includes("@")) {
    throw new Error("Invalid email address");
  }

  const [localPart, domain] = email.split("@");

  if (localPart.length <= 2) {
    // Very short usernames (e.g., ab@example.com) -> keep first letter only
    return localPart[0] + "***" + "@" + domain;
  }

  // Show only first and last char of local part, replace the rest with *
  const visibleFirst = localPart[0];
  const visibleLast = localPart[localPart.length - 1];
  const stars = "*".repeat(localPart.length - 2);

  return `${visibleFirst}${stars}${visibleLast}@${domain}`;
}

export { anonymizeEmail };
